//Dreamcatcher Mobile Enhancements
$(function () {
  $(function () {
    var mobile = false;
    var desktop = false;
    var $window = $(document);
    function checkWidth() {
      var windowsize = $window.width();
      if (windowsize <= 520) {
        if (!mobile) {
          $("body.productPg ul.breadcrumb").prependTo("div.content");
          $("body.categoryPg ul.breadcrumb").prependTo("div.content");
          $("div.item-image").insertAfter("ul.breadcrumb");
          $("body.productPg div.item-image a img")
            .not("ul.alt-views a img")
            .unwrap();
          $("body[id*='pgStep'] div.hdr-promo").insertAfter("div.header");
        }
        mobile = true;
        desktop = false;
      } else {
        if (!desktop) {
          $("body.productPg ul.breadcrumb").insertBefore("div.product-content");
          $("body.categoryPg ul.breadcrumb").insertBefore(
            "div.category-content"
          );
          $("div.item-image").prependTo("div.product-content");
          $("body[id*='pgStep'] div.hdr-promo").insertAfter("div.nav");
        }
        mobile = false;
        desktop = true;
      }
    }
    checkWidth();
    $(window).on("resize", checkWidth);
  });

  //Buttons for activating menus
  $(function () {
    $("#btn-track-order").on("click", function () {
      $(this).toggleClass("closed open").next().slideToggle("fast");
      $(this).html(
        $(this).html() == "Order Tracking" ? "Close" : "Order Tracking"
      );
    });
    $("#btn-main-nav").on("click", function () {
      $(this).toggleClass("inactive activated").next().slideToggle("fast");
      $("#btn-track-order").html(
        $("#btn-track-order").html() == "Close"
          ? "Order Tracking"
          : "Order Tracking"
      );
    });
  });
  $(function () {
    $("#btn-left-nav").on("click", function () {
      $(this)
        .toggleClass("leftnav-inactive leftnav-active")
        .next()
        .toggle("fast");
    });
  });

  //Product Page Item description collapse and tabs
  $(function () {
    $("#item-description")
      .not("html.lt-ie8 #item-description, html.lt-ie9 #item-description")
      .on("click", function () {
        $(this).next().toggle("item-copy");
        $(this).html(
          $(this).html() == "Close product information"
            ? "View product information"
            : "Close product information"
        );
        $(this).toggleClass("closed opened");
        return false;
      })
      .next()
      .hide();
    $("#tabs div").hide();
    $("#tabs div:first").show();
    $("#tabs ul li:first").addClass("active");
    $("#tabs ul li a").on("click", function () {
      $("#tabs ul li").attr("class", "");
      $(this).parent().attr("class", "active");
      var currentTab = $(this).attr("href");
      $("#tabs div").hide();
      $(currentTab).show();
      return false;
    });
  });

  //Fixed Scrolling Cart
  (function ($) {
    $.fn.jScroll = function (options) {
      var opts = $.extend({}, $.fn.jScroll.defaults, options);
      return this.each(function () {
        var $element = $(this);
        var $window = $(window);
        var locator = new location($element);
        $window.on("scroll", function () {
          $element.stop().animate(locator.getMargin($window), opts.speed);
        });
      });

      function location($element) {
        this.min = $element.offset().top;
        this.originalMargin = parseInt($element.css("margin-top"), 10) || 0;
        this.getMargin = function ($window) {
          var max = $element.parent().height() - $element.outerHeight();
          var margin = this.originalMargin;
          if ($window.scrollTop() >= this.min)
            margin = margin + opts.top + $window.scrollTop() - this.min;
          if (margin > max) margin = max;
          return {
            marginTop: margin + "px",
          };
        };
      }
    };
    $.fn.jScroll.defaults = {
      speed: "slow",
      top: -36,
    };
  })(jQuery);

  $(function () {
    $(".productPg .grid-6rt").not(".mobile .grid-6rt").jScroll();
  });

  //Same height rows
  $(function () {
    window.equalheight = function (container) {
      var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = [],
        $el,
        topPosition = 0;
      $(container).each(function () {
        $el = $(this);
        $($el).height("auto");
        topPosition = $el.position().top;

        if (currentRowStart != topPosition) {
          for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
          }
          rowDivs.length = 0;
          currentRowStart = topPosition;
          currentTallest = $el.height();
          rowDivs.push($el);
        } else {
          rowDivs.push($el);
          currentTallest =
            currentTallest < $el.height() ? $el.height() : currentTallest;
        }
        for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
      });
    };

    const equalheightLoad = function () { 
      equalheight(".col");
      equalheight(".item a h2");
    }
    
    window.addEventListener('load', equalheightLoad);
    window.addEventListener('resize', equalheightLoad);
  });

  $(function () {
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1;
    if (isAndroid) {
      $(".overlay").addClass("android");
    }
  });
  // @End

  // Replace email input values with trimmed values
  $(function () {
    $("input[type='email']").on("blur", function () {
      if ($(this).val()) {
        var trimmedEmailVal = $(this).val().trim();
        $(this).val(trimmedEmailVal);
      }
    });
  });

  //GA config-->
  var _gaq = _gaq || [];
  _gaq.push(["_setAccount", "UA-32601214-14"]);
  _gaq.push(["_trackPageview"]);

  (function () {
    var ga = document.createElement("script");
    ga.type = "text/javascript";
    ga.async = true;
    ga.src =
      ("https:" == document.location.protocol ? "https://ssl" : "http://www") +
      ".google-analytics.com/ga.js";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(ga, s);
  })();
});
